import Vue from 'vue';
import { Store } from 'vuex';
import { IStore } from '@/store';

export default abstract class VueBase extends Vue {
  public $store!: Store<IStore>;
}
